import BaseBehavior from '../../../framework/base/base';
import { hideElement } from '../../../shared/utilities/show-hide';
import { showOptions, toggleArrow } from '../../../shared/utilities/dropdownUtils';

export default class CheckboxDropdown extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.addEventListeners();
		// default check first option
		this.dom.items.firstElementChild.firstElementChild.checked = true;
		this.subscribe('reset-to-default', ({ dpElement }) => {
			if (dpElement.contains(element)) {
				const firstOption = this.dom.items.firstElementChild;
				this.changeCheckboxesState(firstOption);
				this.changeDropdownValue(firstOption);
				this.publish('reset-done', { dpElement, filterId: element.dataset.dropdownId });
			}
		});
	}

	onChange(e) {
		const { nodeName } = e.target;
		let selectedElement;
		if (nodeName === 'UL') return false;
		if (e.target.closest('li').querySelector('input').checked) return false; // is already selected

		if (nodeName === 'LI') {
			selectedElement = e.target;
		} else {
			selectedElement = e.target.parentElement;
		}

		this.changeCheckboxesState(selectedElement);
		this.changeDropdownValue(selectedElement);
		this.hideOptions();
		if (this.element.dataset.publishChange === 'true') {
			const dpFilter = this.element.closest('.dynamic-pricing__filters');
			const targetID = dpFilter ? dpFilter.dataset.guid : '';
			this.publish(`/cb-dropdown/change`, {
				dropdownId: this.element.dataset.dropdownId,
				value: selectedElement.children[0].value,
				targetID
			});
		}
		return true;
	}

	changeCheckboxesState(selected) {
		// have selected checkbox checked and others unchecked
		Array.from(this.dom.items.children).forEach(li => {
			li.firstElementChild.checked = li === selected;
		});
	}

	changeDropdownValue(selected) {
		const input = this.element.querySelector('.anchor-text--optional');
		const logo = selected.querySelector('.instrument__logo');
		const logoContainer = this.element.querySelector('.anchor-text--logo');
		if (logo && logoContainer) {
			logoContainer.innerHTML = logo.outerHTML;
		}
		if (!logo && logoContainer) {
			logoContainer.innerHTML = '';
		}
		input.innerText = selected.textContent.trim();
		input.dataset.value = selected.querySelector('input[type=checkbox]').value;
	}

	hideOptions() {
		hideElement(this.dom.items);
		toggleArrow(this.dom.anchorElem, 'v2-arrow-indicator--up', 'v2-arrow-indicator--down');
	}

	addEventListeners() {
		this.addEventListener(document, 'click', e => {
			if (e.target.closest('.dropdown-check-list')) {
				e.preventDefault();
				return;
			}
			this.hideOptions();
		});
		this.addEventListener(this.dom.anchorElem, 'click', evt => {
			evt.preventDefault();
			if (this.dom.items.classList.contains('v2-hidden')) {
				showOptions(this.dom.anchorElem, this.dom.items);
			} else {
				this.hideOptions();
			}
		});

		this.addEventListener(this.dom.items, 'click', this.onChange.bind(this));
	}

	removeEventListeners() {
		this.removeEventListener(this.dom.items, 'click');
		this.removeEventListener(this.dom.anchorElem, 'click');
	}

	cleanup() {
		this.removeEventListeners();
	}
}
